import { render, staticRenderFns } from "./viewFileEditor.vue?vue&type=template&id=df3b598a&scoped=true&lang=pug"
import script from "./viewFileEditor.vue?vue&type=script&lang=js"
export * from "./viewFileEditor.vue?vue&type=script&lang=js"
import style0 from "./viewFileEditor.vue?vue&type=style&index=0&id=df3b598a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3b598a",
  null
  
)

export default component.exports